export enum DataType {
  ID = "ID",
  OBJECT_ID = "OBJECT_ID",
  GUEST_STATUS = "GUEST_STATUS",
  CTA = "CTA",
  ACTION = "ACTION",
  STRING = "STRING",
  LONG = "LONG",
  DOUBLE = "DOUBLE",
  CURRENCY = "CURRENCY",
  BOOLEAN = "BOOLEAN",
  EMAIL = "EMAIL",
  URL = "URL",
  DATE = "DATE",
  DATE_TIME = "DATE_TIME",
  TIME = "TIME",
  SINGLE_SELECT = "SINGLE_SELECT",
  MULTI_SELECT = "MULTI_SELECT",
  IMAGE = "IMAGE",
  COMPANIONS = "COMPANIONS",
  EMAIL_STATUS = "EMAIL_STATUS",
  LIMITS = "LIMITS",
  EVENT_LIMIT_META = "EVENT_LIMIT_META",
  CHECK_IN_OUT = "CHECK_IN_OUT",
  CHECK_IN_STATUS = "CHECK_IN_STATUS",
  CHECK_IN_LOG_ACTION = "CHECK_IN_LOG_ACTION",
  CHECK_IN_LOG_CTA = "CHECK_IN_LOG_CTA",
  ATTACHMENTS = "ATTACHMENTS",
  SLOTTING = "SLOTTING",
  SEATING = "SEATING",
  UNKNOWN = "UNKNOWN",
}
